import {Injectable} from '@angular/core';
import {LorenBaseEndpointsService} from '../../../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service';

@Injectable({
    providedIn: 'root'
})
export class LorenAdminChannelsEndpointsService extends LorenBaseEndpointsService {

    constructor() {
        super();
    }

    public channels() {
        return `${this.getApiServerUrl()}/channels`;
    }
}
